import { render, staticRenderFns } from "./Versicherungsumfang.vue?vue&type=template&id=0b711237&"
import script from "./Versicherungsumfang.vue?vue&type=script&lang=js&"
export * from "./Versicherungsumfang.vue?vue&type=script&lang=js&"
import style0 from "./Versicherungsumfang.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
